module.exports = __webpack_public_path__ + "images/0aa69c0bc367aeba3805719fafd44403.png";